import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';
import api from './middleware/api';


export const store = configureStore({
  reducer,
  middleware: [
    api,
  ],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// export default function () {
//     return configureStore({
//         reducer,
//         middleware: [
//             ...getDefaultMiddleware(),
// api,
// ]
// })
// }
